import styled from 'styled-components';

export const ControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  margin-left: 5px;
  height: 100%;
`;

export const ControlsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
